import { UserChangePassForm } from "@/features"
import styles from "./styles.module.scss"

export const ChangePasswordPage = () => {
  return (
    <div className={styles.page}>
      <UserChangePassForm />
    </div>
  )
}
